<!-- @format -->

<div class="completion-method-repeats">
  @for (repeatPossibility of displayableRepeatGroups; track repeatPossibility; let i = $index) {
    <p>
      <span
        translate="STUDIES.COURSE_UNITS_COMPLETION_METHODS.COMPLETION_METHOD.TEACHING_TIMING"
        [translateParams]="{ index: i + 1 }"></span>
      @for (periodGroup of repeatPossibility; track periodGroup) {
        <span class="sis-period-indicator">
          {{ periodGroup.startPeriod.name | localizedString }}
          @if (periodGroup.startPeriod.defaultValid.endDate !== periodGroup.endPeriod.defaultValid.endDate) {
            <span> - {{ periodGroup.endPeriod.name | localizedString }} </span>
          }
        </span>
      }
    </p>
  }
  @if (!displayableRepeatGroups || displayableRepeatGroups.length === 0) {
    <p class="guidance" translate="STUDIES.COURSE_UNITS_COMPLETION_METHODS.COMPLETION_METHOD.NO_STUDY_PERIOD_REPEAT"> </p>
  }
</div>
